import {z} from 'zod';

const gameConfigSchema = z.object({
    correctPointsPlus: z.number(),
    wrongPointsMinus: z.number(),
    gameClock: z.number(),
    isGamificationOn: z.boolean().optional(),
});

export const gameConfigValidator = gameConfigSchema;
